import { render, staticRenderFns } from "./chatFlowNodeComponent.vue?vue&type=template&id=38b8bf3c"
import script from "./chatFlowNodeComponent.vue?vue&type=script&lang=js"
export * from "./chatFlowNodeComponent.vue?vue&type=script&lang=js"
import style0 from "./chatFlowNodeComponent.vue?vue&type=style&index=0&id=38b8bf3c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports